import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { telegramApi, type TelegramPutInput, type TelegramTestInput } from '../api/telegram';

export const TELEGRAM_KEY = ['admin', 'telegram'] as const;

export function useTelegramConfig() {
  return useQuery({ queryKey: TELEGRAM_KEY, queryFn: () => telegramApi.get() });
}

export function useUpdateTelegram() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: TelegramPutInput) => telegramApi.put(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: TELEGRAM_KEY }),
  });
}

export function useTestTelegram() {
  return useMutation({
    mutationFn: (body: TelegramTestInput) => telegramApi.test(body),
  });
}
